import { JourneyProductsSkeleton } from "../JourneyProducts"
import s from "./Journey.module.scss"
import { JourneyHeader } from "./JourneyHeader"

export const JourneySkeleton = () => {
  return (
    <div className={s.skeleton}>
      <JourneyHeader.Skeleton />

      <JourneyProductsSkeleton />
    </div>
  )
}
